import { render, staticRenderFns } from "./AgendaEditForm.vue?vue&type=template&id=79619488&scoped=true&"
import script from "./AgendaEditForm.vue?vue&type=script&lang=js&"
export * from "./AgendaEditForm.vue?vue&type=script&lang=js&"
import style0 from "./AgendaEditForm.vue?vue&type=style&index=0&id=79619488&lang=scss&scoped=true&"
import style1 from "./AgendaEditForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79619488",
  null
  
)

export default component.exports